import { config } from 'client/hooks/config';
import type * as api from 'common/types/api';
import { StreamDetails } from 'common/types/procedure';
import { Api } from 'common/utils/api';
import { useQuery } from 'react-query';

type useGetProcedureStreamsParameters = {
    procedureId?: number;
    enabled?: boolean;
};
type Response = api.GetProcedureStreamsResponse;

export const useGetProcedureStreamsForExport = ({
    procedureId,
    enabled = true,
}: useGetProcedureStreamsParameters): {
    streams?: StreamDetails[];
    isLoading: boolean;
} => {
    const { key, path } = config.videoexport.vodsForExport(procedureId);
    const { data, isLoading } = useQuery(key, () => Api.get<Response>({ path }), {
        retry: false,
        enabled,
    });
    return { streams: data || [], isLoading };
};
